import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import config from "../../config/config";
import moment from "moment";
import { event } from "jquery";
import { set } from "react-hook-form";
import jsPDF from "jspdf";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../DatePicker/CommonDatePicker";
import CurrencySymbols from "../../common/CurrencySymbol";
import { AppContext } from "../../context/AppContext";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import ReportDate from "../Reports/ReportDate";

const SupplierStatement = () => {
  const { CurrencySymbol, FractionDigits, dateFormate } = useContext(AppContext);
  const paramObject = useParams();
  let ID = paramObject.id;
  const token = localStorage.getItem("Token");
  const Location = localStorage.getItem("Location");

  const [supplierDetails, setSupplierDetails] = useState([]);
  const [statementList, setStatementList] = useState([]);
  const [dateFilter, setDateFilter] = useState();
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  //const [beginningDate, setBeginningDate] = useState( moment().startOf("month").format("YYYY-MM-DD"));
  //const [finalDate, setFinalDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const [beginningDate, setBeginningDate] = useState("");
  const [finalDate, setFinalDate] = useState("");

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [selectReport, setSelectReport] = useState(1);
  const [selectedDate, setSelectedDate] = useState([]);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  console.log(dateFilter, "dateFiltercheck");

  // const columns = useMemo(() => [
  //   {

  //     //     //         <Link className="btn btn-primary btn-sm btn-custom-padding"
  //     //     //           to={`/manage-customers/${row.Id}`}
  //     //     //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //     //     //         >
  //     //     //           Edit
  //     //     //         </Link>
  //     //     //       )}
  //     //     //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
  //     //     //         <>
  //     //     //           <button
  //     //     //             type="button"
  //     //     //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //     //     //             data-bs-toggle="dropdown"
  //     //     //             aria-haspopup="true"
  //     //     //             aria-expanded="false"
  //     //     //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //     //     //           >
  //     //     //           </button>
  //     //     //           <div className="dropdown-menu">
  //     //     //             {checkUserPermission(PERMISSION_EDIT) ? (
  //     //     //               <li>
  //     //     //                 <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
  //     //     //                   <i className="fa fa-edit" title="Edit"></i>Edit
  //     //     //                 </Link>
  //     //     //               </li>
  //     //     //             ) : (
  //     //     //               ""
  //     //     //             )}
  //     //     //             {checkUserPermission(PERMISSION_DELETE) ? (
  //     //     //               <li>
  //     //     //                 <Link
  //     //     //                   className="dropdown-item confirm-text"
  //     //     //                   to="#"
  //     //     //                   title="Delete"
  //     //     //                   data-bs-toggle="modal"
  //     //     //                   data-bs-target="#DeleteConfirmationModal"
  //     //     //                   onClick={() => handleDeletePopup(row.Id)}
  //     //     //                 >
  //     //     //                   <i
  //     //     //                     className="fa fa-trash"
  //     //     //                     data-bs-toggle="tooltip"
  //     //     //                     title="Delete"
  //     //     //                   ></i>
  //     //     //                   Delete
  //     //     //                 </Link>
  //     //     //               </li>
  //     //     //             ) : (
  //     //     //               ""
  //     //     //             )}
  //     //     //           </div>
  //     //     //         </>
  //     //     //       )}
  //     //     //     </div>
  //     //     //   ),
  //     //     //   ignoreRowClick: true,
  //     //     //   allowOverflow: true,
  //     //     //   button: true,
  //     //     //   //width: "7%",//"100px",
  //     //     //   minWidth: "90px",
  //     //     //   width: "90px",
  //     //     // },
  //     //     // {
  //     //     //   name: "Company Name",
  //     //     //   selector: "CompanyName",
  //     //     //   sortable: true,
  //     //     //   width: "170px",
  //     //     //   cell: (row) => (

  //     //     //     <>
  //     //     //       {checkUserPermission(PERMISSION_EDIT) ?
  //     //     //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
  //     //     //           {row.CompanyName}
  //     //     //         </Link>
  //     //     //         :
  //     //     //         row.CompanyName
  //     //     //       }
  //     //        header: "Company Name",
  //     //       accessorKey: "CompanyName",
  //     //       // enableGrouping: false, //do not let this column be grouped
  //     //     },
  //     //     {
  //     //       header: "Name",
  //     //       accessorKey: "Name",
  //     //       Cell: ({ row }) => (
  //     //         <>
  //     //           <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
  //     //             {row.original.FirstName} {row.original.LastName}
  //     //           </Link>
  //     //         </>
  //     //       ),

  //     //       // enableGrouping: false, //do not let this column be grouped
  //     //     },
  //     //     // {
  //     //     //   header: "DATE",
  //     //     //   accessorKey: "DATE",
  //     //     //   Cell: ({row})=> moment(row.original.DATE).format('YYYY-MM-DD')
  //     //     // },
  //     //     {
  //     //       header: "E-Mail",
  //     //       accessorKey: "Email",
  //     //       Cell: ({ row }) => (
  //     //         <>
  //     //           <p title={row.original.Email}>{row.original.Email}</p>
  //     //         </>
  //     //       ),
  //     // =======
  //     header: "Date",
  //     accessorKey: "Date",
  //     Cell: ({ row }) => moment(row.original.Date).format("MM/DD/YYYY ")
  //   },
  //   {
  //     header: "Details",
  //     accessorKey: "Details",

  //   },
  //   {
  //     header: "Amount",
  //     accessorKey: "Amount",
  //   },
  //   {
  //     header: "Payments",
  //     accessorKey: "Payments",
  //   },
  //   {
  //     header: "Balance",
  //     accessorKey: "Balance",

  //   },

  //   {
  //     header: "Profile",
  //     accessorKey: "Image",
  //     Cell: ({ row }) => (
  //       <>
  //         <a href={row.original.Image} target="_blank">
  //           <img
  //             src={row.original.Image}
  //             alt="Profile Image"
  //             style={{
  //               maxWidth: "30px",
  //               maxHeight: "70px",
  //               margin: "5px",
  //             }}
  //             onError={(e) => {
  //               e.target.onerror = null;
  //               e.target.src = Noimage;
  //             }}
  //           ></img>
  //         </a>
  //       </>
  //     ),
  //   },
  //   {
  //     header: "Created On",
  //     accessorKey: "CreatedDate",
  //     Cell: ({ row }) => formatDate(row.original.CreatedDate),
  //   },  {
  //     header: "Account Balance",
  //     accessorKey: "Balance",
  //     Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
  //   },
  // ]);

  const columns = [
    {
      name: "Date",
      width: "160px",
      selector: (row) => moment(row["Date"]).format("MM/DD/YYYY "),
      sortable: false,
    },
    {
      name: "Details",
      // width: "420px",
      size: 180,
      cell: (row) => {
        return <div>{row?.Details}</div>;
      },
      sortable: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "3px",
          }}
        >
          Credit
        </div>
      ),
      cell: (row) => {
        return (
          <div className="text-right">
            {CurrencySymbols(
              Number(row?.Payments),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* {`$${Number(row?.Payments).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
          </div>
        );
      },
      sortable: true,
      right: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "22px",
          }}
        >
          Debit
        </div>
      ),
      // width:"125px",
      // cell: (row) => {
      //   return (
      //     <div className="text-right" style={{ width: "98px" }}>
      //       {`$${Number(row?.Amount).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`}
      //     </div>
      //   );
      // },
      cell: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {CurrencySymbols(
              Number(row?.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* {`$${Number(row?.Payments).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
          </div>
        );
      },
      sortable: true,
      right: true,
    },
    {
      name: (
        <div
          style={{
            marginLeft: "30px",
          }}
        >
          Balance
        </div>
      ),
      width: "130px",
      // cell: (row) => {
      //   return (
      //     <div className="text-right" style={{ width: "98px" }}>
      //       {`$${Number(row?.Balance).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`}
      //     </div>
      //   );
      // },
      cell: (row) => {
        return (
          <div className="text-right" style={{ width: "98px" }}>
            {CurrencySymbols(
              Number(row?.Balance),
              { CurrencySymbol },
              FractionDigits
            )}
            {/* {`$${Number(row?.Payments).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
          </div>
        );
      },
      sortable: true,
      right: true,
    },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });
  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 2 },
    { label: "Last Year", value: 3 },
    { label: "This Month", value: 4 },
    { label: "This Week", value: 5 },
    { label: "This Year", value: 6 },
    { label: "Period", value: 7 },
    { label: "Last Month", value: 8 },
  ];

  //Date

  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  // const handleQuickBookChange = (event) => {
  //   console.log(event, "eventtt");
  //   setDateFilter(event?.value);
  //   if (event?.value !== 7) {
  //     setStartDate(moment().format("YYYY-MM-DD"));
  //     setEndDate(moment().format("YYYY-MM-DD"));
  //   }
  //   if (event?.value == 1) {
  //     setBeginningDate("");
  //     setFinalDate("");
  //   } else if (event?.value == 5) {
  //     setBeginningDate(startOfWeek);
  //     setFinalDate(endOfWeek);
  //   } else if (event?.value == 4) {
  //     setBeginningDate(startOfMonth);
  //     setFinalDate(endOfMonth);
  //   } else if (event?.value == 8) {
  //     setBeginningDate(startOfLastMonth);
  //     setFinalDate(endOfLastMonth);
  //   } else if (event?.value == 6) {
  //     setBeginningDate(startOfYear);
  //     setFinalDate(endOfYear);
  //   } else if (event?.value == 3) {
  //     setBeginningDate(startOfLastYear);
  //     setFinalDate(endOfLastYear);
  //   }
  // };

  // const handleDate = (event) => {
  //   console.log(event?.target?.value, "eventisss92");
  //   setStartDate(event?.target?.value);
  //   setBeginningDate(event?.target?.value);
  // };

  // const handleDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     // const datetime =
  //     //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     // const settime = moment(datetime).format("YYYY-MM-DD");
  //     // console.log(settime, "settime");
  //     setBeginningDate(selectedDate);
  //     setStartDate(selectedDate);
  //   }
  // };

  // const handleEndDate = (event) => {
  //   setEndDate(event?.target?.value);
  //   setFinalDate(event?.target?.value);
  // };

  // const handleEndDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     // const datetime =
  //     //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     // const settime = moment(datetime).format("YYYY-MM-DD");
  //     // console.log(settime, "settime");
  //     setFinalDate(selectedDate);
  //     setEndDate(selectedDate);
  //   }
  // };

  console.log(dateFilter, "dateFilter");

     useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setBeginningDate("");
      setFinalDate("");
    }
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    // if (selectReport != 2){
      setBeginningDate(payload);
      setFinalDate(enddate2);
    // }

    console.log("enddate =>", enddate2);
  };

    useEffect(() => {
      if (selectReport != 2) {
        supplierStatementApi();
      }
    }, [beginningDate,finalDate]);

  //Search Button
  const handleSearch = () => {
    console.log(startDate, endDate, "1555");
    supplierStatementApi(beginningDate, finalDate);
  };

  const dateFilterData =
    dateFilter == 2 ? (
      <p>
        {moment(beginningDate).format("MM-DD-YYYY") +
          " To " +
          moment(beginningDate).format("MM-DD-YYYY")}
      </p>
    ) : dateFilter === 5 ? (
      <p>{startOfWeek + " To " + endOfWeek}</p>
    ) : dateFilter === 4 ? (
      <p>
        {moment(startOfMonth).format("MM-DD-YYYY") +
          " To " +
          moment(endOfMonth).format("MM-DD-YYYY")}
      </p>
    ) : dateFilter === 8 ? (
      <p>
        {moment(startOfLastMonth).format("MM-DD-YYYY") +
          " To " +
          moment(endOfLastMonth).format("MM-DD-YYYY")}
      </p>
    ) : dateFilter === 6 ? (
      <p>
        {moment(startOfYear).format("MM-DD-YYYY") +
          " To " +
          moment(endOfYear).format("MM-DD-YYYY")}
      </p>
    ) : dateFilter === 3 ? (
      <p>
        {moment(startOfLastYear).format("MM-DD-YYYY") +
          " To " +
          moment(endOfLastYear).format("MM-DD-YYYY")}
      </p>
    ) : dateFilter === 7 ? (
      startDate === undefined ? (
        <p>
          {moment(today).format("MM-DD-YYYY") +
            " To " +
            moment(today).format("MM-DD-YYYY")}
        </p>
      ) : (
        <p>
          {moment(startDate).format("MM-DD-YYYY") +
            " To " +
            moment(endDate).format("MM-DD-YYYY")}
        </p>
      )
    ) : (
      // <p>{moment(startOfMonth).format('MM-DD-YYYY') + " To " + moment(endOfMonth).format('MM-DD-YYYY')}</p>
      <p>All Data</p>
    );

  const supplierStatementApi = () => {
    // let sDate = beginningDate == undefined ? startOfYear : beginningDate;
    // let fDate = finalDate == undefined ? endOfYear : finalDate;
    let sDate = beginningDate;
    let fDate = finalDate;
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierstatement?supplierid=${ID}&startdate=${sDate}&enddate=${fDate}&Locationid=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res, "res138");
        setSupplierDetails(res?.data?.ResponseData?.SupplierDetails);
        setStatementList(res?.data?.ResponseData?.StatementList);
      });
  };

  useEffect(() => {
    supplierStatementApi();
  }, [dateFilter]);

  console.log("statementList 242", statementList);

  // Print Statement Function-
  const handlePrint = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 15;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(statementList.length / 24); i++) {
      if (i >= 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "1.5rem";
      }

      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">S.No.</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Date</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Details</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Amount</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Payments</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < statementList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr style='border-bottom: 0.5px solid  #f2f2f2; padding-top: 5px'>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          moment(statementList[index].Date).format("MM/DD/YYYY ") +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px; width: 300px;font-family: Inter, sans-serif;">' +
          statementList[index].Details +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          statementList[index].Amount +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          statementList[index].Payments +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          statementList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 24;
    }

    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  // Send Mail Function-
  const handleMailPdf = () => {
    var doc = new jsPDF("p", "pt", "a4");

    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `8px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let dateHeaderElement = document.querySelector("#date-header");
    let clonedDateHeader = dateHeaderElement.cloneNode(true);
    clonedDateHeader.style.fontSize = `8px`;
    clonedDateHeader.style.width = "560px";
    document.querySelector("#date-header p").style.margin = 0;

    let content = "";
    let startIndex = 0;
    let endIndex = 15;

    content += " " + clonedHeader.outerHTML;

    // Loop through the customerList array
    for (var i = 0; i < Math.ceil(statementList.length / 24); i++) {
      if (i >= 0) {
        content += " " + clonedDateHeader.outerHTML;
        clonedDateHeader.style.marginTop = "1.5rem";
      }
      // Printing table body-
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">S.No.</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Date</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Details</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Amount</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Payments</th>' +
        '<th style="padding: 5px;background-color: #d4d4d4;font-size: 12px;font-family: Inter, sans-serif">Balance</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (
        let index = startIndex;
        index < statementList.length && index <= endIndex;
        index++
      ) {
        content +=
          "<tr style='border-bottom: 0.5px solid  #f2f2f2; padding-top: 5px'>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          (index + 1) +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          moment(statementList[index].Date).format("MM/DD/YYYY ") +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif; width: 300px">' +
          statementList[index].Details +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          statementList[index].Amount +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          statementList[index].Payments +
          "</td>" +
          '<td style="font-size: 7px; padding: 8px;font-family: Inter, sans-serif;">' +
          statementList[index].Balance +
          "</td>" +
          "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      // Update startIndex and endIndex for the next iteration
      startIndex = endIndex + 1;
      endIndex = startIndex + 24;
    }

    doc.html(content, {
      callback: function (pdf) {
        const pdfBlob = pdf.output("blob");

        // Create a data URL from the PDF Blob
        const pdfDataUrl = URL.createObjectURL(pdfBlob);

        // Prepare the email subject and body
        const emailSubject = encodeURIComponent("");
        const emailBody = encodeURIComponent("");

        // Create the mailto link with the PDF data URL as attachment
        const mailtoLink = `mailto:?subject=${emailSubject}&body=${emailBody}&attachment=${pdfDataUrl}`;

        // Open the default email client (Gmail) with the mailto link
        window.location.href = mailtoLink;
      },
    });
  };

  return (
    <div className="">
      <div className="card bg-white" style={{ borderRadius: "10px" }}>
        <div style={{ fontWeight: "300", margin: "10px 0 0 10px" }}>
          <h4 className="card-title">Supplier Statement</h4>
        </div>
        <hr style={{ color: "#cfcfcf" }} />
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            // marginTop: "20px",
          }}
        >
          <div style={{ width: "20%", marginLeft: "20px" }}>
            <label className="col-form-label col-md-12 form-label p-lg-medium">Date Filter: </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={reportdropdown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                // isClearable={true}
                name="Reportperiod"
                id="Reportperiod"
                value={reportdropdown.find((e) => e.value === selectReport)}
                onChange={(event) => {
                  handleDropdownChange(event);
                }}
                className="custom-search-select"
              ></Select>
          </div>
          {selectReport !== 1 && (
              <div className="col-sm-4 ms-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            {selectReport === 2 && (
            <div>
              <label className="col-form-label form-label p-lg-medium mt-2"> </label>
              <button
                className="btn btn-primary"
                style={{
                  height: "fit-content",
                  marginTop: "30px",
                }}
                onClick={(e) => handleSearch(e)}
              >
                Search
              </button>
            </div>
          )}
          {/* {dateFilter === 7 && (
            <>
              <div style={{ width: "20%", marginTop: "3px" }}>
                Start Date:-
                <CommonDatePicker
                  FinalDate={startDate}
                  handleDateChange={handleDate}
                />
              </div>
              <div style={{ width: "20%", marginTop: "3px" }}>
                End Date:-
                <CommonDatePicker
                  FinalDate={endDate}
                  handleDateChange={handleEndDate}
                />
              </div>
              <button
                className="btn btn-primary"
                style={{
                  height: "fit-content",
                  marginTop: "22px",
                }}
                onClick={(e) => handleSearch(e)}
              >
                Search
              </button>
            </>
          )} */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginRight: "20px",
            }}
          >
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-print" onClick={handlePrint} />
            </div>
            <div
              style={{
                marginTop: "8px",
                padding: "6px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                cursor: "pointer",
                color: "#415164",
                backgroundColor: "#f1f5f7",
                textTransform: "uppercase",
                fontSize: "13.5px",
              }}
            >
              <i className="fa fa-envelope" onClick={handleMailPdf} />
            </div>
          </div>
        </div>
        {/* Print Statement */}
        <div className="card-body">
          <div
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            {/* Header */}
            <div id="header">
              <div className="text-right">
                {supplierDetails?.map((el) => {
                  return (
                    <>
                      <p
                        className="h-tag"
                        style={{
                          fontWeight: "bold",
                          margin: "0",
                        }}
                      >
                        {el?.Companyname}
                      </p>
                      <span>{el?.Address1 + " " + el?.Address2}</span>
                      <br />
                      <span>
                        {el?.City +
                          ", " +
                          el?.State +
                          " " +
                          el?.Zip +
                          ", " +
                          el?.Country}
                      </span>
                      <br />
                      {/* <span>{el?.Zip}</span> */}
                    </>
                  );
                })}
              </div>
              <hr style={{ color: "#cfcfcf" }} />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {supplierDetails?.map((el) => {
                  return (
                    <div
                      style={{
                        width: "22%",
                        display: "flex",
                        //justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <strong>To: </strong>
                        {el?.FirstName + " " + el?.LastName}
                      </div>
                    </div>
                  );
                })}
                <div className="text-right">
                  <strong>Account Summary</strong>
                  {dateFilterData}
                </div>
              </div>
              <hr
                style={{ width: "20%", marginLeft: "auto", color: "#cfcfcf" }}
              />
              <div>
                {supplierDetails?.map((el) => {
                  return (
                    <>
                      <div>
                        <div>
                          <span className="text-left">
                            <strong>Opening Balance: </strong>
                            {/* {el?.BeginningBalance} */}
                            {CurrencySymbols(
                              Number(el?.BeginningBalance),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                            {/* {`$${Number(el?.BeginningBalance).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
                          </span>
                          <span className="text-left">
                            {/* <strong> | Bill Amount:</strong>${el?.BillAmount} */}
                            <strong> | Bill Amount: </strong>
                            {/* {`$${Number(el?.BillAmount).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
                            {CurrencySymbols(
                              Number(el?.BillAmount),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                          </span>
                          <span className="text-left">
                            <strong> | Journal Credits: </strong>
                            {/* {el?.JournalCreditsAmount > 0
                            ? `$${Number(el?.JournalCreditsAmount).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`
                            : 0} */}
                            {//el?.JournalCreditsAmount > 0 ?
                               CurrencySymbols(
                                  Number(el?.JournalCreditsAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )
                              }
                          </span>
                          <span className="text-left">
                            <strong> | Deposit Amount: </strong>
                               {CurrencySymbols(
                                  Number(el?.DepositAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              
                          </span>
                          <span className="text-left">
                            <strong> | CC Credit: </strong>
                               {CurrencySymbols(
                                  Number(el?.CCCreditAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              
                          </span>
                          <span className="text-left">
                            <strong> | Amount Paid: </strong>
                            {/* {el?.AmountPaid > 0 
                            ? `$${Number(el?.AmountPaid).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`
                             : 0} */}
                            {//el?.AmountPaid > 0 ? 
                              CurrencySymbols(
                                  Number(el?.AmountPaid),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                          </span>
                          <span className="text-left">
                            <strong> | Credit Memo: </strong>
                            {//el?.CreditAppliedAmount > 0 ?
                               CurrencySymbols(
                                  Number(el?.CreditAppliedAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )
                              }
                            {/* {el?.CreditAppliedAmount > 0
                            ? `$${Number(el?.CreditAppliedAmount).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`
                            : 0} */}
                          </span>
                          <span className="text-left">
                            <strong> | Journal Debits: </strong>
                            {/* {el?.JournalDebitsAmount > 0
                            ? `$${Number(el?.JournalDebitsAmount).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`
                            : 0} */}
                            {//el?.JournalDebitsAmount > 0?
                             CurrencySymbols(
                                  Number(el?.JournalDebitsAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                          </span>
                          <span className="text-left">
                            <strong> | Expense Amount: </strong>
                            {
                             CurrencySymbols(
                                  Number(el?.ExpenseAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                          </span>
                          <span className="text-left">
                            <strong> | Check Amount: </strong>
                            {
                             CurrencySymbols(
                                  Number(el?.CheckAmount),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                          </span>
                        </div>
                      </div>
                      <hr
                        style={{
                          width: "20%",
                          color: "#cfcfcf",
                        }}
                      />
                      <div>
                        <strong>Balance Due:</strong>

                        <div>
                          {CurrencySymbols(
                            Number(el?.BalanceDue),
                            { CurrencySymbol },
                            FractionDigits
                          )}
                          {/* {`$${Number(el?.BalanceDue).toLocaleString("en-US" , {minimumFractionDigits : 2 , maximumFractionDigits : 2})}`} */}
                        </div>
                        {/* <div>${el?.BalanceDue}</div> */}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>

            {/* Date Header */}
            <div
              id="date-header"
              style={{ textAlign: "center", margin: "20px 0 20px 0" }}
            >
              <p>
                Showing all Bills and payments between                
              </p>
              <p><strong>{beginningDate === "" && finalDate === ""
                                          ? "All Data"
                                          : moment(beginningDate).format(
                                              `${dateFormate.toUpperCase()}`
                                            ) +
                                            " - " +
                                            moment(finalDate).format(
                                              `${dateFormate.toUpperCase()}`
                                            )}</strong></p>
            </div>

            {/* Table Data */}
            <div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={statementList}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  sortServer
                  dense
                />
                {/* <MaterialReactTable
            columns={columns}
            data={data}
            // positionPagination='top'
            enableColumnResizing
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            enableRowActions
           
            renderRowActionMenuItems={({ row }) =>

              [
                checkUserPermission(PERMISSION_EDIT) ? (
                  <MenuItem
                    key="edit"
                    onClick={() =>
                      navigate(
                        `/manage-customers/${row.original.Id}`
                      )
                    }
                  >
                    Edit
                  </MenuItem>
                ) : (
                  ""
                ),
                checkUserPermission(PERMISSION_DELETE) ? (
                  <MenuItem
                    className="confirm-text"
                    to="#"
                    // key="delete"

                    title="Delete"
                    data-bs-toggle="modal"
                    data-bs-target="#DeleteConfirmationModal"
                    onClick={() =>
                      handleDeletePopup(row.original.Id,"","singlerowdelete")
                    }
                  >
                    Delete
                  </MenuItem>
                ) : (
                  ""
                ),
              ]
            }


        

            rowVirtualizerOptions={{
              overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
              estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
            }}


            muiTableContainerProps={{
              sx: { maxHeight: "fit-content" },
            }}
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 10 },
              // sorting: { id: "Name", desc: false }, //sort by state by default
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [10, 25, 50, 100, 300],
            }}
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            // enableColumnVirtualization={false}
            // enableColumnVirtualization
            state={{
              // columnFilters, // for termp comment filteron column
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />  */}
              </div>
              <div
                style={{
                  textAlign: "right",
                  marginTop: "2rem",
                }}
              >
                {supplierDetails?.map((el) => (
                  <p style={{ margin: "1rem" }}>
                    <strong>Balance Due </strong>{" "}
                    <span style={{ marginLeft: "2rem" }}>
                      {/* ${el?.BalanceDue} */}
                      {`$${Number(el?.BalanceDue).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierStatement;
